import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index';
import Layout from '@/components/Layout';
import VisitorTracker, { getRouteTitlePath } from "@linsy-utils/page-trace";
import { getLoginUser, changeUserInfoResolved } from '@/routes/helper';
// import { setArmsConfig } from '../utils/arms';
import watermarkGuard from './guard/watermark';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

import fixedAssets from '@/routes/modules/fixedAssets';
import mutualHelp from '@/routes/modules/mutualHelp'; // 爱心互助
import purchase from '@/routes/modules/purchase'; // 采购管理
import officeSupplies from '@/routes/modules/officeSupplies'; // 办公用品
import achievements from '@/routes/modules/achievements';
import orgPersonnel from '@/routes/modules/orgPersonnel'; // 组织人事
import recruitment from '@/routes/modules/recruitment'; // 招聘管理
import IntegrityZon from '@/routes/modules/IntegrityZon'; // 廉洁管理
import salaryManagement from '@/routes/modules/salaryManagement'; // 薪酬管理
import postIncentive from '@/routes/modules/postIncentive'; // 岗位激励
import targetManagement from '@/routes/modules/targetManagement.js'; // 岗位激励
import employeeContract from '@/routes/modules/employeeContract.js'; // 员工合同
import serviceConfig from '@/routes/modules/serviceConfig.js'; // 业务配置
import video from '@/routes/modules/video.js'; // 视频配置
import projectManagement from '@/routes/modules/projectManagement.js'; //工程项目管理
import humanResources from '@/routes/modules/humanResources.js'; // 人力驾驶仓
import talentInventory from '@/routes/modules/talentInventory.js'; // 人力驾驶仓
import ssoSetting from './modules/ssoSetting'; // sso配置
import notice from './modules/notice'; // sso配置
import electronicRecordsManagement from '@/routes/modules/electronicRecordsManagement.js'; // 电子档案管理
import attendanceSetting from './modules/attendanceSetting'; // 考勤管理
import institution from './modules/institution'; // 企标制度
import institutionKnowledge from './modules/institutionKnowledge'; // 企标知识库
import companyFlow from './modules/companyFlow'; // 企业流程
import projectPortal from '@/routes/modules/projectPortal.js'; // 企标制度
import systematicOperation from './modules/systematicOperation'; // 系统运维
import train from './modules/train'; // 培训管理
import viProtal from './modules/viProtal'; // VI门户
import directorPortal from './modules/directorPortal'; // 董事长门户
import guide from '@/routes/modules/guide'; // 招聘管理
import projectBoard from '@/routes/modules/projectBoard'; // 项目看板
import purchasesWelfare from '@/routes/modules/purchasesWelfare'; // 内购福利
import newsManagement from '@/routes/modules/newsManagement'; // 新闻管理
import materialManagement from '@/routes/modules/materialManagement'; // 物资管理
import socialSecurityAndHousingFund from '@/routes/modules/socialSecurityAndHousingFund'; // 社保公积金
import processLink from '@/routes/modules/processLink'; // 流程链路
import dormManagement from '@/routes/modules/dormManagement'; // 宿舍管理
import carManagement from '@/routes/modules/carManagement'; // 车辆管理
import corporateCulture from '@/routes/modules/corporateCulture'; // 企文专区
import questionnaireManage from '@/routes/modules/questionnaireManage'; // 问卷模板管理
import talentInspection from '@/routes/modules/talentInspection';

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index',
      component: Layout,
      children: [
        {
          path: 'index',
          name: 'index',
          component: () => import('@/views/indexPage.vue'),
          meta: {
            title: '首页',
            fixedTab: true
          }
        },
        {
          name: 'depCompany',
          path: '/manage/depCompany',
          component: () => import('@/views/manage/depCompany.vue'),
          meta: {
            title: '部门关联公司'
          }
        },
        ...recruitment,
        ...fixedAssets,
        ...purchase,
        ...officeSupplies,
        ...achievements,
        ...orgPersonnel,
        ...IntegrityZon,
        ...salaryManagement,
        ...postIncentive,
        ...mutualHelp,
        ...targetManagement,
        ...employeeContract,
        ...serviceConfig,
        ...video,
        ...projectManagement,
        ...humanResources,
        ...talentInventory,
        ...ssoSetting,
        ...notice,
        ...electronicRecordsManagement,
        ...attendanceSetting,
        ...systematicOperation,
        ...institution,
        ...institutionKnowledge,
        ...companyFlow,
        ...train,
        ...viProtal,
        ...projectPortal,
        ...directorPortal,
        ...guide,
        ...projectBoard,
        ...purchasesWelfare,
        ...newsManagement,
        ...materialManagement,
        ...socialSecurityAndHousingFund,
        ...processLink,
        ...dormManagement,
        ...carManagement,
        ...corporateCulture,
        ...questionnaireManage,
        ...talentInspection
      ]
    },
    {
      name: '404',
      path: '/404',
      component: {
        render() {
          return (
            <a-result status="404" title="404" sub-title="抱歉，页面不存在">
              <template slot="extra">
                <a-button type="primary">
                  <router-link to={'/'}>回到首页</router-link>
                </a-button>
              </template>
            </a-result>
          );
        }
      }
    },
    {
      name: '403',
      path: '/403',
      component: {
        render() {
          return (
            <a-result
              status="403"
              title="403"
              sub-title="没有权限，请联系管理员"
            >
              <template slot="extra">
                <a-button type="primary">
                  <router-link to={'/'}>重试</router-link>
                </a-button>
              </template>
            </a-result>
          );
        }
      }
    },
    {
      name: 'fallback',
      path: '*',
      redirect: '/404'
    },
    // 合同签署后提示页面
    {
      name: 'contractSignTips',
      path: '/contractSignTips',
      component: () => import('@/components/ContractSignTips/index.vue'),
      meta: {
        title: '合同签署后提示'
      }
    },
    // 硬装集采合同签署后提示页面
    {
      name: 'hardboundTipsTips',
      path: '/hardboundTipsTips',
      component: () => import('@/components/HardboundTips/index.vue'),
      meta: {
        title: '合同签署后提示'
      }
    },
    // OA 跳转固定资产详情
    {
      name: 'oaJumpAssetDetail',
      path: '/oa-jump/oaJumpAssetDetail',
      component: () =>
        import('@/views/fixedAssets/assetPurchasingList/assetPurchasingDetail'),
      meta: {
        title: '固定资产申请详情'
      }
    },
    // OA 跳转办公用品详情
    {
      name: 'oaJumpOfficeDetail',
      path: '/oa-jump/officePurchaseDetail',
      component: () =>
        import(
          '@/views/officeSupplies/officePurchase/officePurchaseDetail.vue'
        ),
      meta: {
        title: '办公用品申请单详情'
      }
    },
    // OA 跳转专项申请详情
    {
      name: 'oaJumpSpecialDetail',
      path: '/oa-jump/oaJumpSpecialDetail',
      component: () => import('@/views/oaJumpOder/specialDetail.vue'),
      meta: {
        title: '专项采购申请详情'
      }
    },
    // OA 跳转专项项目详情
    {
      name: 'oaJumpProjectInfo',
      path: '/oa-jump/oaJumpProjectInfo',
      component: () => import('@/views/oaJumpOder/projectInfo.vue'),
      meta: {
        title: '项目详情'
      }
    },
    // 采购合同-合同详情
    {
      name: 'purchaseOrderDetails',
      path: '/purchaseOrder/details',
      component: () => import('@/views/purchaseOrder/purchaseOrderDetails.vue'),
      meta: {
        title: '采购合同明细'
      }
    },
    // 请示详情
    {
      name: 'oaJumpAskInfo',
      path: '/oa-jump/oaJumpAskInfo',
      component: () => import('@/views/oaJumpAsk/oaJumpAskInfo.vue'),
      meta: {
        title: '请示详情'
      }
    },
    // OA 跳转战略项目详情
    {
      name: 'oaJumpStrategicProjectInfo',
      path: '/oa-jump/oaJumpStrategicProject',
      component: () => import('@/views/oaJumpOder/strategicProject.vue'),
      meta: {
        title: '项目详情'
      }
    },
    // 地址更换公告
    {
      path: '/urlChangeNotice',
      component: () => import('@/views/urlChangeNotice/index.vue'),
      name: 'urlChangeNotice',
      meta: {
        title: '地址更换公告',
        disabledHead: true
      },
      props: (route) => ({ ...route.query })
    },
    {
      name: 'ResumePreview',
      path: '/resumePreview',
      component: () =>
        import(
          '@/views/recruitment/candidateFormal/preview/resumePreview/index.vue'
        ),
      meta: {
        title: '标准简历',
        hidenWatermark: true,
      },
      props: (route) => ({
        ...route.query
      })
    },
    {
      name: 'printHtmlPage',
      path: '/printHtmlPage',
      component: () => import('@/views/recruitment/candidateFormal/preview/resumePreview/typeHtml.vue'),
      meta: {
        title: '导出pdf',
        hidenWatermark: true,
      },
      props: (route) => ({
        ...route.query
      })
    },
    // 钉钉流程中查看面试评价，会重定向到 EvaluationFormPreview
    {
      path: '/evaluation-form-preview/:applyId',
      meta: {
        title: '面试评价',
        hidenWatermark: true,
      },
      redirect: (route) => ({
        name: 'EvaluationFormPreview',
        query: {
          applyId: route.params.applyId
        }
      })
    },
    {
      name: 'EvaluationFormPreview',
      path: '/evaluation-form-preview',
      component: () =>
        import(
          '@/views/recruitment/candidateFormal/preview/evaluationFormPreview/index.vue'
        ),
      meta: {
        title: '面试评价',
        hidenWatermark: true,
      },
      props: (route) => ({
        ...route.query
      })
    },
    // 查看简历详情，会重定向到 candidateDetail，只有简历和备注查看
    {
      path: '/candidateDetail/sample/:applyId',
      name: 'CandidateDetailPreviewSample',
      redirect: route => ({
        name: 'CandidateDetailPreview',
        query: {
          applyId: route.params.applyId,
          authMode: 'noAuth'
        }
      })
    },
    {
      path: '/candidateDetail/share/:applyId',
      redirect: (route) => ({
        name: 'CandidateDetailPreview',
        query: {
          applyId: route.params.applyId,
          authMode: 'share'
        }
      })
    },
    {
      path: '/candidateDetail/share/:applyId/:forwardId',
      redirect: (route) => ({
        name: 'CandidateDetailPreview',
        query: {
          applyId: route.params.applyId,
          forwardId: route.params.forwardId,
          authMode: 'share'
        }
      })
    },
    {
      name: 'CandidateDetailPreview',
      path: '/candidateDetail',
      component: () =>
        import(
          '@/views/recruitment/candidateFormal/preview/candidateDetailPreview/index.vue'
        ),
      meta: {
        title: '简历详情'
      },
      props: (route) => ({
        ...route.query
      })
    },
    {
      name: 'CandidateHtmlFilePreview',
      path: '/candidateHtmlFilePreview',
      component: () =>
        import(
          '@/views/recruitment/candidateFormal/preview/candidateHtmlFilePreview/index.vue'
        ),
      meta: {
        title: '简历预览'
      },
      props: (route) => ({
        ...route.query
      })
    },
    {
      name: 'CandidateDetailBatchPreview',
      path: '/candidateDetailBatch',
      component: () => import('@/views/recruitment/candidateFormal/preview/candidateDetailPreview/batch.vue'),
      meta: {
        title: '批量查看简历'
      },
      props: route => ({
        ...route.params,
        ...route.query
      })
    },
    {
      name: 'SupplierRegistration',
      path: '/supplierRegistration',
      component: () =>
        import(
          '@/views/purchaseManagement/supplierManagement/allowApplications/supplierRegistration.vue'
        ),
      meta: {
        title: '供应商注册登记表'
      },
      props: (route) => ({
        ...route.query,
        ...route.params
      })
    },
    {
      name: 'purchaseLeadsDetailForSee',
      path: '/purchase/pruchaseLeadsForSee/detail',
      component: () =>
        import(
          '@/views/purchaseManagement/purchaseLeads/purchaseLeadsDetail.vue'
        ),
      meta: {
        title: '采购需求申请单详情'
      }
    },
    {
      name: 'sourcingPriceConfirmDetailView',
      path: '/purchase/sourcingManagement/sourcingPriceConfirm/detail/view',
      component: () =>
        import('@/views/purchaseManagement/sourcingManagement/detail/view.vue'),
      meta: {
        parentAuth: '/purchase/sourcingManagement/sourcingPriceConfirm',
        title: '寻源核价详情'
      }
    },
    {
      path: "/previewPdf",
      name: "previewPdfService",
      component: () => import("@/components/pdfPreview/index.vue"),
      meta: {
        title: "PDF预览",
      },
      props: route => ({
        ...route.params,
        ...route.query
      })
    },
    {
      path: "/previewFile",
      name: "previewFileService",
      component: () => import("@/components/previewFile/index.vue"),
      meta: {
        title: "预览服务",
      },
      props: route => ({
        ...route.params,
        ...route.query
      })
    },
    {
      name: 'PersonalSupplierReserveList',
      path: '/purchase/supplierManagement/reserve/personal-list',
      component: () => import('@/views/purchaseManagement/supplierManagement/reserve/list.vue'),
      meta: {
        title: '供应商储备申请'
      },
      props: route => ({
        ...route.params,
        ...route.query,
        pageUserType: 'employee'
      })
    },
    {
      name: 'PersonalSupplierReserveDetail',
      path: '/purchase/supplierManagement/reserve/personal-detail',
      component: () =>
        import(
          '@/views/purchaseManagement/supplierManagement/allowApplications/detail.vue'
        ),
      meta: {
        title: '供应商储备申请'
      },
      props: route => ({
        ...route.query,
        pageUserType: 'employee',
        formType: 'reserve'
      })
    },
    // 查看岗位详情，提供给门户使用
    {
      name: 'jobDescriptionDetailPreview',
      path: '/jobDescriptionDetailPreview',
      component: () =>
        import('@/views/orgPersonnel/jobDescription/jobDescriptionDetail'),
      meta: {
        title: '岗位详情'
      },
      props: route => ({
        ...route.query,
        mode: 'portalView',
      })
    },
    {
      name: 'employeeSalaryDetail',
      path: '/employeeSalaryDetail',
      component: () =>
        import('@/views/salaryManagement/salaryActivity/components/employeeSalaryDetail.vue'),
      meta: {
        title: '工资条'
      },
      props: route => ({
        ...route.query,
      })
    },
    {
      name: 'costPriceLibrary',
      path: '/costPriceLibrary',
      component: () =>
        import('@/views/purchaseManagement/costPriceLibrary/list.vue'),
      meta: {
        title: '成本价格库'
      },
      props: route => ({
        ...route.query,
      })
    },
    // 架构预调整预览页，独立全屏页，无需菜单权限
    {
      name: 'architecturePreAdjustmentPreview',
      path: '/orgPersonnel/architecturePreAdjustment/preview',
      component: () =>
        import(
          '@/views/orgPersonnel/departmentManagement/architecturePreAdjustment/viewPage.vue'
        ),
      meta: {
        title: '架构预调整预览'
      }
    },
    {
      name: 'fileDownload',
      path: '/fileDownload',
      component: () =>
        import('@/views/salaryManagement/fileDownload/index.vue'),
      meta: {
        title: '下载页'
      },
      props: route => ({
        ...route.query,
      })
    },
    {
      name: 'authFileDownload',
      path: '/authFileDownload',
      component: () =>
        import('@/views/salaryManagement/authFileDownload/index.vue'),
      meta: {
        title: '下载页'
      },
      props: route => ({
        ...route.query,
      })
    }
  ]
});

const allowRouteList = [
  '/login',
  '/404',
  '/403',
  '/oa-jump/oaJumpAssetDetail',
  '/oa-jump/officePurchaseDetail',
  '/oa-jump/oaJumpSpecialDetail',
  '/oa-jump/oaJumpProjectInfo',
  '/contractSignTips',
  '/oa-jump/oaJumpStrategicProject',
  '/purchaseOrder/details',
  '/hardboundTipsTips',
  '/oa-jump/oaJumpAskInfo',
  '/resumePreview',
  '/evaluation-form-preview',
  '/candidateDetail',
  '/candidateDetailBatch',
  '/urlChangeNotice',
  '/supplierRegistration',
  '/purchase/sourcingManagement/sourcingPriceConfirm/detail/view',
  '/purchase/pruchaseLeadsForSee/detail',
  '/previewPdf',
  '/previewFile',
  '/printHtmlPage',
  '/purchase/supplierManagement/reserve/personal-list',
  '/purchase/supplierManagement/reserve/personal-detail',
  '/jobDescriptionDetailPreview',
  '/employeeSalaryDetail',
  '/costPriceLibrary',
  '/fileDownload',
  '/authFileDownload',
  '/candidateHtmlFilePreview',
  '/orgPersonnel/architecturePreAdjustment/preview'
];

const routeGuard = (to, from, next) => {
  titleHandler(to);

  if (allowRouteList.indexOf(to.path) > -1) {
    next();
    return;
  }
  if (
    Object.values(store.state.user.menuMap).find(
      (_) => _.url === to.path || _.url === to.meta?.parentAuth
    )
  ) {
    next();
  } else {
    next({
      path: '/403'
    });
  }
};

/**
 * 处理页签标签
 * @param {*} to
 */
const titleHandler = (to) => {
  let title = to?.meta?.title;

  if (typeof title === 'function') {
    title = title(to);
  }

  document.title = `${title}-HR管理系统后台` || 'HR管理系统后台';
};

// 创建追踪器实例
const tracker = new VisitorTracker({
  uploadUrl: process.env.VUE_APP_TRACE_URL, // 追踪地址
  batchSize: 1,
  trackAnonymous: false,
  disable: process.env.NODE_ENV === "development",
  plugins: [
    (data) => {
      data = {
        ...data,
        originSystem: "OA-DHR", // 系统标识符，每个系统需唯一
        path: getRouteTitlePath(data.url, router.getRoutes())
      }
      console.log('追踪器 data: ', data);
      return data
    }
  ],
});


router.beforeEach((to, from, next) => {
  if (from.path === '/403' || to.path === 'login') {
    changeUserInfoResolved(false);
  }
  if (allowRouteList.indexOf(to.path) === -1) {
    getLoginUser()
      .then(() => {
        routeGuard(to, from, next);

        // 启用ARMS埋点的uid和用户名
        try {
          let userInfo = store.state.user.userInfo || {};
          if (userInfo.code) {
            // 设置用户信息
            tracker.setUserInfo({
              no: userInfo.code,
            });

            // setArmsConfig({
            //   setUsername: () => `${userInfo.nickName}(${userInfo.code})`
            // });
          }
        } catch (error) {
          console.log(error);
        }
      })
      .catch((err) => {
        console.log(err, process.env.VUE_APP_SSO_LOGIN_PAGE);
        if (process.env.NODE_ENV === 'production' && err?.code === '302') {
          const redirectUrl = window.location.href;
          window.location.href = `${process.env.VUE_APP_SSO_LOGIN_PAGE}?redirectUrl=${redirectUrl}`;
        }
      });
  } else {
    titleHandler(to);
    next();
  }
});

router.afterEach((to, from) => {
  const cachedRoutes = store.state.app.cachedRoutes;
  if (
    !cachedRoutes.find((item) => {
      return (
        item.path === to.path &&
        JSON.stringify(item.query) === JSON.stringify(to.query)
      );
    }) &&
    allowRouteList.indexOf(to.path) === -1
  ) {
    store.commit('app/addCachedRoute', { to, from });
  }
  store.commit('app/setCurrentPath', to.fullPath);
});

watermarkGuard(router);

export default router;
